import React, { useCallback, useContext, useEffect, useState } from "react";
import "./WinToolbar.less";
import IconFont from "@/components/icon";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useTranslation } from "react-i18next";
import { FocusSDK, isFocusEnv } from "@/utils";
import Prompt from "@/baseComponents/ModalComponent/prompt";
import bus from "@/utils/bus";
import { APP_NAME } from "@/config/name";
import { connect } from "dvajs";

const MinIcon = <IconFont type="iconwin_Minimize" />;
const MaxIcon = <IconFont type="iconwin_Full" />;
const WinIcon = <IconFont type="iconwin_window" />;
const CloseIcon = <IconFont type="iconwin_Close" />;

interface WinToolbarProps {
  appFrame: string;
  isLogin: boolean;
  onItemClick: (button: "min" | "max" | "normal" | "quit") => void;
  themes: any;
}

type AppFrameType = "min" | "max" | "unMax" | "hide" | "close";

function WinToolbar({
  ishidewin,
  isclosewin,
  wrapperDoubleClickTrigger,
  themes
}: {
  ishidewin?: boolean;
  isclosewin?: boolean;
  wrapperDoubleClickTrigger?: number;
  themes: any;
}) {
  const [t_common] = useTranslation("common");
  const { appRuntimeEnv, focusSDK, localConfigData } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const [active, setActive] = useState(false);
  const isLogin = !!appRuntimeEnv.registryConfig.auth;
  const [isMax, setIsMax] = useState(isFocusEnv() ? focusSDK?.getWindowFrame("max") : "");

  const onItemClick = useCallback(
    (appFrame: AppFrameType, window?: string) => {
      focusSDK.setWindowFrame(appFrame, window);
      setTimeout(() => {
        setIsMax(focusSDK.getWindowFrame("max"));
      }, 0);
      const domMessageScroll: any = document.getElementById("message-box-container-scroll");
      if (!domMessageScroll) return;
      if (appFrame) {
        domMessageScroll.scrollTop = domMessageScroll.scrollHeight;
      }
    },
    [focusSDK]
  );
  const mainWinMaximize = useCallback(() => {
    setTimeout(() => {
      setIsMax(focusSDK.getWindowFrame("max"));
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const mainWinUnmax = useCallback(() => {
    setTimeout(() => {
      setIsMax(focusSDK.getWindowFrame("min"));
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    focusSDK.on("main-win-maximize", mainWinMaximize);
    focusSDK.on("main-window-unmax", mainWinUnmax);
    return () => {
      focusSDK.off("main-win-maximize", mainWinMaximize);
      focusSDK.off("main-window-unmax", mainWinUnmax);
    };
  }, [focusSDK, mainWinMaximize, mainWinUnmax]);

  useEffect(() => {
    if (wrapperDoubleClickTrigger && wrapperDoubleClickTrigger > 1) {
      onItemClick(isMax ? "unMax" : "max");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperDoubleClickTrigger]);

  const handleClose = useCallback(() => {
    if (isclosewin) {
      onItemClick("close");
      return;
    }
    if (ishidewin) {
      onItemClick("hide");
      return;
    }
    const closeApp = localConfigData?.settings?.closeApp;
    if (closeApp) {
      Prompt({
        title: t_common("setting.tip"),
        content: `确定要退出${APP_NAME}吗?`,
        okText: t_common("setting.confirm"),
        cancelText: t_common("setting.cancel"),
        onOk: async () => {
          onItemClick("close");
        }
      });
    } else {
      onItemClick("hide");
    }
  }, [isclosewin, ishidewin, localConfigData, onItemClick, t_common]);

  const handleSetActive = useCallback((data) => {
    setActive(data);
  }, []);

  useEffect(() => {
    bus.on("supervise:IconActive", handleSetActive);
    return () => {
      bus.off("supervise:IconActive", handleSetActive);
    };
  }, [handleSetActive]);

  // if (appRuntimeEnv.registryConfig.client !== 'WINDOWS') {
  //     return null;
  // }
  function onToolbarContextMenu() {
    if (focusSDK.isBeta()) {
      focusSDK.openDevTools();
    }
  }
  return (
    <div
      className={["winToolBar", isLogin ? "winToolLogin" : "", themes].join(" ")}
      onContextMenu={onToolbarContextMenu}
    >
      {(ishidewin || appRuntimeEnv.registryConfig.client === "WINDOWS") && (
        <>
          <div
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            className="winToolItem"
            onClick={() => {
              onItemClick("min");
            }}
          >
            {MinIcon}
          </div>
          <div
            className="winToolItem"
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={() => {
              onItemClick(isMax ? "unMax" : "max");
            }}
          >
            {focusSDK.getWindowFrame("max") ? WinIcon : MaxIcon}
          </div>
          <div
            className={["winToolItem", "close"].join(" ")}
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={handleClose}
          >
            {CloseIcon}
          </div>
        </>
      )}
    </div>
  );
}
function mapStateToProps(props: { user: any; }) {
  const { user } = props;
  return {
    themes: user?.themes
  };
}
export default connect(mapStateToProps)(WinToolbar);